export const ideaStepFluxUpdateConstants = {
    SET_NEW_CONTENT_FLUX: "SET_NEW_CONTENT_FLUX",
    SET_EDIT_IDEA_STEP_FLUX_ASSOCIATIONS_STATE: "SET_EDIT_IDEA_STEP_FLUX_ASSOCIATIONS_STATE",
    EDIT_IDEA_STEP_FLUX_UPDATE_ASSOCIATIONS_REQUEST: 'EDIT_IDEA_STEP_FLUX_UPDATE_ASSOCIATIONS_REQUEST',
    EDIT_IDEA_STEP_FLUX_UPDATE_ASSOCIATIONS_SUCCESS: 'EDIT_IDEA_STEP_FLUX_UPDATE_ASSOCIATIONS_SUCCESS',
    EDIT_IDEA_STEP_FLUX_UPDATE_ASSOCIATIONS_FAILURE: 'EDIT_IDEA_STEP_FLUX_UPDATE_ASSOCIATIONS_FAILURE',
    EDIT_IDEA_STEP_FLUX_UPDATE_IS_GENERIC: 'EDIT_IDEA_STEP_FLUX_UPDATE_IS_GENERIC',
    EDIT_IDEA_STEP_FLUX_UPDATE_CLEAR_ALL: 'EDIT_IDEA_STEP_FLUX_UPDATE_CLEAR_ALL'
}